import { render, staticRenderFns } from "./ReportProvidersTransactionScreen.vue?vue&type=template&id=5d4fa8ab&scoped=true&"
import script from "./ReportProvidersTransactionScreen.vue?vue&type=script&lang=js&"
export * from "./ReportProvidersTransactionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fa8ab",
  null
  
)

export default component.exports